import { createBrowserRouter } from 'react-router-dom';

export const tireWarrantyRouter = createBrowserRouter([
  // Home (réutilise home-dipropneu)
  {
    path: '/',
    lazy: () => import('../home-dipropneu/Layout').then(m => ({ Component: m.Layout })),
    children: [
      {
        index: true,
        lazy: () => import('../home-dipropneu/pages/HomePage').then(m => ({ Component: m.HomePage })),
      },
    ],
  },
  // Souscription par facture (réutilise souscription-facture)
  {
    path: '/souscription',
    lazy: () => import('../souscription-facture/Layout').then(m => ({ Component: m.Layout })),
    children: [
      {
        index: true,
        lazy: () => import('../souscription-facture/pages/SouscriptionPage').then(m => ({ Component: m.SouscriptionPage })),
      },
      {
        path: 'success',
        lazy: () => import('../souscription-facture/pages/SuccessPage').then(m => ({ Component: m.SuccessPage })),
      },
    ],
  },
  // Déclaration (orchestrator : login → consultation SAV → formulaire 3 étapes)
  {
    path: '/declaration',
    lazy: () => import('./declaration/Layout').then(m => ({ Component: m.Layout })),
    children: [
      {
        index: true,
        lazy: () => import('./declaration/DeclarationPage').then(m => ({ Component: m.DeclarationPage })),
      },
    ],
  },
  // Pages légales (réutilisables par tous les clients tire-warranty)
  {
    path: '/',
    lazy: () => import('./legal/LegalLayout').then(m => ({ Component: m.LegalLayout })),
    children: [
      {
        path: 'legal-notice',
        lazy: () => import('./legal/pages/LegalNoticesPage').then(m => ({ Component: m.LegalNoticesPage })),
      },
      {
        path: 'privacy-policy',
        lazy: () => import('./legal/pages/PrivacyPolicyPage').then(m => ({ Component: m.PrivacyPolicyPage })),
      },
      {
        path: 'terms-and-conditions',
        lazy: () => import('./legal/pages/TermsAndConditionsPage').then(m => ({ Component: m.TermsAndConditionsPage })),
      },
    ],
  },
  // 404 — wrappé dans home-dipropneu/Layout pour avoir accès à BrandThemeProvider
  {
    path: '*',
    lazy: () => import('../home-dipropneu/Layout').then(m => ({ Component: m.Layout })),
    children: [
      {
        index: true,
        lazy: () => import('../home-dipropneu/NotFound').then(m => ({ Component: m.default })),
      },
    ],
  },
]);
